window.addEventListener('load', (event) => {
   
    $(".accordion-item").click(function(e){
            $(this).toggleClass("expanded");
    });

});
